import Vue from 'vue'
import Router from 'vue-router'
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const VueRouterPush = Router.prototype.push 
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

const EntryIndex = ()=>import('@/components/Common/Site/EntryIndex')
const PIndex = ()=>import('@/components/Pt/PIndex.vue')
const Kczx = ()=>import('@/components/Pt/Pc/Kczx/Index.vue')
const Wdkc  = ()=>import('@/components/Pt/Pc/Wdkc/Index.vue')
const Dwlb = ()=>import('@/components/Pt/Pc/Index/ForclassIndex/CooperationPartner.vue')
const Sjtj = ()=>import('@/components/Pt/Pc/Sjtj/Index.vue')

const ButtonsFang = ()=>import('@/components/Pt/Mobile/comomon/ButtonsFang.vue')
const ButtonsFang11 = ()=>import('@/components/Pt/Mobile/comomon/ButtonsFang11.vue')



const CreateCourseFirst  = ()=>import('@/components/Pt/Pc/Wdkc/CreateCourseFirst.vue')
// const CreateCourseSecond  = ()=>import('@/components/Pt/Pc/Wdkc/CreateCourseSecond.vue')
const CreateCourseSecond  = ()=>import('@/components/Pt/Pc/Common/Kcxq/Index.vue')
const Sjxq = ()=>import('@/components/StudyDesign/Common/Sjxq.vue')
const StudyStatic = ()=>import('@/components/StudyDesign/Use/UseIndex')


const CreateCourseList  = ()=>import('@/components/Pt/Pc/Wdkc/CreateCourseList.vue')
const CourseStudy  = ()=>import('@/components/Pt/Pc/Wdkc/CourseStudy.vue')
const AuditCourse  = ()=>import('@/components/Pt/Pc/Wdkc/AuditCourse.vue')
const CourseTeach = ()=>import('@/components/Pt/Pc/Wdkc/CourseTeach.vue')


//移动端路由

//课程详情
const MKcxq = ()=>import('@/components/Pt/Mobile/Kcxq/Index.vue')
const TaskCard = ()=>import('@/components/Pt/Mobile/Kcxq/TaskCard.vue')
const StudyStructure = ()=>import('@/components/Pt/Mobile/Kcxq/StudyStructure.vue')
const MEachTask = ()=>import('@/components/Pt/Mobile/Kcxq/EachTask.vue')
const MResPreview = ()=>import('@/components/Pt/Mobile/Common/MResPreview')


// 我的作品
const WdzpIndex =()=>import('@/components/Pt/Mobile/Wdzp/Index.vue') 
const WorkSubmit =()=>import('@/components/Pt/Mobile/Wdzp/WorkSubmit.vue') 
const CommentView =()=>import('@/components/Pt/Mobile/Kcxq/TaskContent/Common/CommentView.vue')



const ListIndex = ()=>import('@/components/StudyDesign/Index')
const CreateList = ()=>import('@/components/StudyDesign/Create/CreateList')
const ShareList = ()=>import('@/components/StudyDesign/Share/ShareList.vue')
const ShareContentList = ()=>import('@/components/StudyDesign/Share/ShareContentList.vue')
const ClassifyList = ()=>import('@/components/StudyDesign/Classify/ClassifyList')
const ClassifyItem = ()=>import('@/components/StudyDesign/Classify/Common/ClassifyItem')
//cdd0327
//课程预览DesignPreviewTop
const DesignPreviewTop = ()=>import('@/components/StudyDesign/Common/DesignTop')
// const TempDesignPreviewTop = ()=>import('@/components/StudyDesign/Common/TempDesignTop')


const DesignStructure = ()=>import('@/components/StudyDesign/Common/DesignStructure')
const DesignPreview = ()=>import('@/components/StudyDesign/Common/DesignPreview')
const DesignEachTask = ()=>import('@/components/StudyDesign/Common/DesignEachTask')

const DesignWholePreview = ()=>import('@/components/StudyDesign/Common/DesignWholePreview')
// const DesignEachPreview = ()=>import('@/components/StudyDesign/Common/DesignEachPreview')

const MobilePreview = ()=>import('@/components/StudyDesign/Common/MobilePreview')



const MakeNew = ()=>import('@/components/StudyDesign/Create/MakeNew')
const DesignTemplate = ()=>import('@/components/StudyDesign/Create/DesignTemplate')


const UseList = ()=>import('@/components/StudyDesign/Use/UseList')
const UseIndex = ()=>import('@/components/StudyDesign/Use/UseIndex')

// 设计使用
const DataStatic = ()=>import('@/components/StudyDesign/Use/DataStatic/DataStatic.vue')
const PersonStatic = ()=>import('@/components/StudyDesign/Use/DataStatic/PersonStatic.vue')
const TaskStatic = ()=>import('@/components/StudyDesign/Use/DataStatic/TaskStatic.vue')
// 客户端预览
const GoToView = ()=>import('@/components/Home/GoToView.vue')

// 不知道路由
const Unknow = ()=>import('@/components/StudyDesign/Create/Unknow')

const StudentDesignList = ()=>import('@/components/StudyDesign/StudentDesignList');
const StudyStore = ()=>import('@/components/StudyDesign/StudyStore/Index.vue');

/* bigin 腾讯 */
const QQRouter = () => import ('@/components/Pt/Pc/QQ/QQRouter');
const QQCourseDetail = () => import ('@/components/Pt/Pc/QQ/Course/Detail.vue');
const QQCourseCreate = () => import('@/components/Pt/Pc/QQ/Course/Create.vue')
const QQCourseCreateSecond = ()=>import('@/components/Pt/Pc/QQ/Course/CreateSecond.vue')

/* end 腾讯 */
Vue.use(Router)

let router =  new Router({
	mode:'history',
	routes: [
		{
			path:'/',
			name:'课程平台首页',
			component:EntryIndex,//页面入口
			children:[{
				path:'/',//pc端课程首页
				name:'课程首页',
				// component:ButtonsFang11
				component:PIndex
			},				
			{
				path:'/Kczx',//pc端课程中心
				name:'课程中心',
				component:Kczx
			},
			{
				path:'/Sjtj',//pc端数据统计
				name:'课程数据统计',
				component:Sjtj
			},
			{
				path:'/Wdkc',//pc端我的课程
				name:'我的课程',
				component:Wdkc,
				// meta: { requiresAuth: true},
				children:[{
					path:'/Wdkc/Xxkc',//pc端课学习课程
					name:'学习课程',
					component:CourseStudy
				},
				{
					path:'/Wdkc/List',//pc端创建课程列表
					name:'创建课程列表',
					component:CreateCourseList
				},
				{
					path:'/Wdkc/CjkcFirst',//pc端创建或编辑课程第一步
					name:'课程第一步',
					component:CreateCourseFirst
				},
				{
					path:'/Wdkc/Kcsk',//pc端课课程授课
					name:'课程授课',
					component:CourseTeach
				},
				{
					path:'/Wdkc/Cjkc',//pc端创建、编辑课程第二部、课程详情页
					name:'创建课程',
					component:CreateCourseSecond,
					children:[{
						path:'/Wdkc/Sjxq',
						name:'学程设计详情',
						component:Sjxq,						
					},{
						path:'/Wdkc/StudyStatic',
						name:'学程设计统计',
						component:StudyStatic,		
						redirect:'/Wdkc/TaskStatic',
						children:[
							{
								path:'/Wdkc/TaskStatic',
								name:'按照任务统计',
								component:TaskStatic,
							},
							{
								path:'/Wdkc/PersonStatic',
								name:'按照人员统计',
								component:PersonStatic,
							},
						]				
					}]
				},
				{
					path:'/Wdkc/Shkc',//pc端课审核课程
					name:'审核课程',
					component:AuditCourse
				}]
			},
			{
				path:'/Tbkc',
				name:'同步课程',
				component:Kczx
			},
			{
				path:'/Xfzd',
				name:'学法指导',
				component:Kczx
			},
			{
				path:'/Ddyxx',
				name:'大单元学习',
				component:Kczx
			},
			{
				path:'/MKcxq',
				name:'移动端课程详情',
				component:MKcxq
			},
			{
				path:'/TaskCard',
				name:'移动端学程设计任务卡片',
				component:TaskCard
			},
			{
				path:'/StudyStructure',
				name:'移动端学程设计结构',
				component:StudyStructure
			},
			{
				path:'/MEachTask',
				name:'移动端学程设计单任务查看',
				component:MEachTask
			},
			{
				path:'/MResPreview',
				name:'移动端资源预览',
				component:MResPreview
			},
			{
				path:'/MWdzp',
				name:'移动端查看我的作品',
				component:WdzpIndex
			},
			{
				path:'/MZpList',
				name:'移动端查看作品列表',
				component:WdzpIndex
			},
			{
				path:'/MZptj',
				name:'移动端查看作品提交',
				component:WorkSubmit
			},
			{
				path:'/Dwlb',//pc端合作单位列表
				name:'合作单位列表',
				component:Dwlb
			},{
				path:'/CommentView',
				name:'互看评价',
				component:CommentView
			}]
		},
		{
			path:'/Hzdw',//pc端合作单位
			name:'合作单位',
			component:EntryIndex,
			children:[{
				path:'/Hzdw',//pc端课程中心
				name:'合作单位课程首页',
				component:PIndex
			},{
				path:'/Hzdw/Kczx',//pc端课程中心
				name:'合作单位课程中心',
				component:Kczx
			},]
		},
		{
			path: '/listindex',
			name: '学习设计',
			component: ListIndex,
			meta: { origin: 'studyDesign'},
				children:[
				{
					path: '/createlist',
					name: '创建列表',
					component: CreateList,
					meta: { origin: 'studyDesign'}
				},
				{
					path: '/sharelist',
					name: '分享',
					component: ShareList,
					meta: { origin: 'studyDesign'},
					children:[{
						path: '/sharelist',
						name: '分享列表',
						component: ShareContentList,
						meta: { origin: 'studyDesign'}
					},{
						path: '/othersharelist',
						name: '他人分享',
						component: ShareContentList,
						meta: { origin: 'studyDesign'}
					}]
				},
				{
					path: '/classifylist',
					name: '分类列表',
					component: ClassifyList,
					meta: { origin: 'studyDesign'}
				},
				{
					path: '/ClassifyItem',
					name: '分类子页',
					component: ClassifyItem,
					meta: { origin: 'studyDesign'}
				},
				{
					path: '/uselist',
					name: '使用列表',
					component: UseList,
					meta: { origin: 'studyDesign'}
				},
			]
		},
		// 中转页面
		{
			path: '/Home/GoToView',
			name: '中转',
			component: GoToView,
			// meta: { baseAlias: 'home', alias: 'home' },
			children: []
		},
		// 课程预览
		{
			path: '/DesignPreview',
			name: '课程预览',
			component: DesignPreviewTop,
			meta: { origin: 'studyDesign'},
			// redirect:'/DesignWholePreview',
			children:[
				// {
				// 	path: '/DesignPreview',
				// 	name: '结构查看',
				// 	component:DesignPreview, 
				// 	meta: { origin: 'studyDesign'}   
				// },
				{
					path: '/DesignPreview',
					name: '结构查看',
					component:DesignStructure, 
					meta: { origin: 'studyDesign'}   
				},
				{
					path: '/DesignWhole',
					name: '整体查看',
					component:DesignPreview , 
					meta: { origin: 'studyDesign'}   
				},
				{
					path: '/DesignEach',
					name: '任务查看',
					component:DesignEachTask,    
					meta: { origin: 'studyDesign'}
				},
				{
					path: '/MobilePreview',
					name: '移动端预览',
					component: MobilePreview,
				},


				// {
				//   path: '/DesignWholePreview',
				//   name: '学程整体查看',
				//   component:DesignWholePreview,    
				// },{
				//   path: '/DesignEachPreview',
				//   name: '学程任务查看',
				//   component:DesignEachPreview,    
				// },
			]
		},
		// {
		// 	path: '/TempDesignPreviewTop',
		// 	name: '学程预览',
		// 	component: TempDesignPreviewTop,
		// 	meta: { origin: 'studyDesign'},
		// 	redirect:'/DesignWholePreview',
		// 	children:[
		// 	{
		// 		path: '/DesignWholePreview',
		// 		name: '学程整体查看',
		// 		component:DesignWholePreview,   
		// 		meta: { origin: 'studyDesign'} 
		// 	},{
		// 		path: '/DesignEachPreview',
		// 		name: '学程任务查看',
		// 		component:DesignEachPreview, 
		// 		meta: { origin: 'studyDesign'}   
		// 	},]
		// },
		{
			path: '/UseIndex',
			name: '学习设计使用',
			component: UseIndex,
			meta: { origin: 'studyDesign'},
			children:[
			{
				path:'/Use/DataStatic',
				name:'数据统计',
				component:DataStatic,
				meta: { origin: 'studyDesign'},
				redirect:'/Use/Data/Task',
				children:[
					{
						path:'/Use/Data/Person',
						name:'按照人员统计',
						component:PersonStatic,
						meta: { origin: 'studyDesign'}
					},
					{
						path:'/Use/Data/Task',
						name:'按照任务统计',
						component:TaskStatic,
						meta: { origin: 'studyDesign'}
					},
				]
			},
			]
		},
		// 学习设计使用
		{
			path: '/makenew',
			name: '创建学习设计',
			component: MakeNew,
			meta: { origin: 'studyDesign'}
		},
		{
			path: '/DesignTemplate',
			name: '创建学习设计模板',
			component: DesignTemplate,
			meta:{
				keepAlive: true,
				origin: 'studyDesign'
			}
		},
		{
			path: '/Unknow',
			name: 'Unknow',
			component: Unknow,
			meta: { origin: 'studyDesign'}
		},
		{
			path: '/StudentList',
			name: 'StudentList',
			component: StudentDesignList,   
			meta: { origin: 'studyDesign' }
		},{
			path: '/StudyStore',
			name: '学程库',
			component: StudyStore,
			meta:{
				keepAlive: true,
				origin: 'studyDesign'
			}
		},{
			path: '/',
			name: '腾讯课程平台',
			component: QQRouter,
			children: [{
				path: '/Ten/Detail',
				name: '课程详情',
				component:QQCourseDetail
			},{
				path: '/Ten/Create',
				name: '筑基课程新建',
				component:QQCourseCreate	
			},{
				path: '/Ten/CreateSecond',
				name: '筑基课程新建第二步',
				component:QQCourseCreateSecond,
				children:[{
					path:'/Ten/Sjxq',
					name:'学程设计详情',
					component:Sjxq					
				 }]	
			}]
        }
	]
})
router.beforeEach((to, from, next) => {
    if (to.meta.origin == 'studyDesign') {  
		parent.postMessage( {fullScreen:'true'}, '*');
		next()
    }
    else {
		parent.postMessage( {fullScreen:'false'}, '*');
        next();
    }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js